import { paddingSmall } from "src/styles/spacing";
import { CommentAttachmentType } from "../types";
import CommentMessageUnsent from "./CommentMessageUnsent";

const CommentAttachmentDeletedThread = ({
	attachment,
}: {
	attachment: CommentAttachmentType.DeletedThread;
}) => {
	return (
		<CommentMessageUnsent
			style={{
				bottom: -paddingSmall,
			}}
		/>
	);
};
export default CommentAttachmentDeletedThread;
